'use client';

import H2 from '@/components/typography/h2';
import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import P from '@/components/typography/p';
import { CopiableEmail } from '@/components/ui/copiable';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

export default function OpenVacContent() {
    const { t } = useTranslation();
    return (
        <>
            {/** Desktop View **/}
            <div className="hidden h-screen w-full lg:flex">
                <div className="border-primary flex h-full w-[42%] flex-col items-center justify-center border-r">
                    <div className="flex flex-col gap-5">
                        <Label>{t('subtitle')}</Label>
                        <H2>{t('title')}</H2>
                    </div>
                    <Image
                        src="/images/stickers/coffe.png"
                        alt="About Us"
                        className="absolute bottom-[-7rem] left-[0rem] z-10 h-[250px] w-auto max-w-full lg:bottom-[-11rem] lg:left-[-20rem] lg:h-[700px]"
                        width={1350}
                        height={1350}
                    />
                </div>
                <div className="flex h-full w-[57%] flex-col items-center justify-center gap-8 px-20 2xl:px-40">
                    <H3 className="text-center">{t('heading')}</H3>
                    <P className="text-center">
                        {t('text')}
                        <CopiableEmail email="merle@foodcabinet.nl" />
                    </P>
                </div>
            </div>
            {/** Mobile View **/}
            <div className="relative flex w-full flex-col lg:hidden">
                <div className="border-primary mt-[54px] flex w-full flex-col justify-center overflow-hidden border-b px-5 py-15">
                    <div className="flex flex-col gap-5">
                        <Label>{t('subtitle')}</Label>
                        <H2>{t('title')}</H2>
                    </div>
                    <Image
                        src="/images/stickers/coffe.png"
                        alt="About Us"
                        className="absolute top-[6rem] right-[-9rem] z-10 h-[300px] w-auto"
                        width={1350}
                        height={1350}
                    />
                </div>
                <div className="flex w-full flex-col items-center justify-center gap-8 px-5 py-15">
                    <H3>{t('heading')}</H3>
                    <P>
                        {t('text')}
                        <CopiableEmail email="merle@foodcabinet.nl" />
                    </P>
                </div>
            </div>
        </>
    );
}
